import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { supabase } from 'src/clientLib/supabase'
import { handleSession } from 'src/redux/slices/user/reducers'
import { selectAuthorized, selectSession } from 'src/redux/slices/user/selectors'

import { AuthChangeEvent } from '@supabase/supabase-js'

import { createAuthTokenCookie } from './endpoints'

const useCreateAuthTokenCookie = createAuthTokenCookie.useMutation

export const useSession = () => {
  const dispatch = useDispatch()
  const authorized = useSelector(selectAuthorized)
  const session = useSelector(selectSession)
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      dispatch(handleSession(session))
    })

    supabase.auth.onAuthStateChange((event, session) => {
      dispatch(handleSession(session))

      if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
        // delete cookies on sign out
        const expires = new Date(0).toUTCString()
        document.cookie = `access_token=; path=/; expires=${expires}; SameSite=None; secure`
        document.cookie = `refresh_token=; path=/; expires=${expires}; SameSite=None; secure`
      } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        if (session) {
          const maxAge = session?.expires_at ?? 0 - Date.now() / 1000 // time in seconds
          document.cookie = `access_token=${session.access_token}; path=/; max-age=${maxAge}; SameSite=None; secure`
          document.cookie = `refresh_token=${session.refresh_token}; path=/; max-age=${maxAge}; SameSite=None; secure`
        }
      }
    })
  }, [dispatch])

  // useSessionCookie()

  return {
    authorized,
  }
}
export const useSessionCookie = () => {
  const session = useSelector(selectSession)
  const [trigger, { data }] = useCreateAuthTokenCookie()

  useEffect(() => {
    if (!session) return
    trigger({ session })
  }, [session, trigger])
}
